import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueApexCharts from 'vue-apexcharts'
import { BASE_URL } from '@/helper/constants'
import BeeComponents from '@beetronix/bee-components'
// import BeeTasking from './plugins/BeeTasking'
import axios from 'axios'
Vue.use(VueApexCharts)
Vue.use(BeeComponents)
// Vue.use(BeeTasking);

Vue.component('apexchart', VueApexCharts)

Vue.config.productionTip = false

window.axios = axios.create({ baseURL: BASE_URL })

window.axios = axios.create({
	baseURL: BASE_URL
})

const eventBus = new Vue();
Vue.prototype.$eventBus = eventBus;

window.axios.interceptors.response.use(
	res => res,
	error => {
		if (!error.response) return Promise.reject(error);
		if (error.response.status === 401 && router.currentRoute.name !== 'login') {
			store.dispatch('auth/logout');
			router.replace({ name: 'login' })
		}
		if (error.response.status === 500) {
			eventBus.$emit(
				'show-snackbar',
				error.response.data ||
				'Internal Server Error',
				'error'
			);
		}
		if (router.currentRoute.name !== 'login' && error.response.status !== 500) {
			eventBus.$emit(
				'show-snackbar',
				error.response.data ||
				error.response.data.title ||
				'An error occurred ',
				'error'
			);
		}

		return Promise.reject(error)
	}
);
if ('self' in localStorage) {
	const self = JSON.parse(localStorage.getItem('self'));
	// store.state.auth.self.name = self.fullName
	store.state.auth.self.id = self.id
	store.state.auth.self.accessToken = self.accessToken
	store.state.auth.self.employeeId = self.employeeId
	store.state.auth.self.userType = self.userType
	store.state.auth.authentication = true
	store.state.auth.self.name = self.name
	const authHeader = `${self.accessToken}`;
	window.axios.defaults.headers.common.Authorization = authHeader;
	store.dispatch('users/fetchById', { id: self.id })
	// setTimeout(store.dispatch('auth/login', { email: 'abd@gmail.com', password: 'secret' }), 3600000);
} else {
	router.replace({ name: 'login' });
}

window.axios.interceptors.response.use(
	res => res,
	error => {
		if (error.response.status === 401 && router.currentRoute.name !== 'login') {
			store.dispatch('auth/logout');
			router.replace({ name: 'login' })
		}
		if (!error.response) return Promise.reject(error);
		return Promise.reject(error)
	}
);

// window.axios.interceptors.response.use(
// 	function (response) {
// 		return response;
// 	},
// 	function (error) {
// 		if (router.currentRoute.name !== 'login') {
// 			store.dispatch('auth/logout');
// 			router.replace({ name: 'login' })
// 		}
// 		return Promise.reject(error);
// 	}
// );
// error.response.status === 401 && 

// remove commit when push api  ////
// window.axios.interceptors.response.use(
// 	function (response) {
// 		return response;
// 	},
// 	function (error) {
// 		if (router.currentRoute.name !== 'login') {
// 			store.dispatch('auth/logout');
// 			router.replace({ name: 'login' })
// 		}
// 		return Promise.reject(error);
// 	}
// );

new Vue({
	router,
	store,
	vuetify,
	render: h => h(App)
}).$mount('#app')
